/**
 * 랜딩 페이지 헤더 컴포넌트
 * 로고, 언어 선택기, 가격 버튼 등을 포함한 상단 헤더
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  backdrop-filter: blur(12px);\n  background-color: rgba(255, 255, 255, 0.8);\n  border-bottom: 1px solid #e5e5e5;\n  transition: all 0.2s ease;\n  padding: 0.75rem 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 0 1rem;\n  \n  @media (min-width: 640px) {\n    padding: 0 1.5rem;\n  }\n  \n  @media (min-width: 1024px) {\n    padding: 0 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  \n  h1 {\n    font-size: 1.5rem;\n    font-weight: bold;\n    background: linear-gradient(90deg, var(--primary, #3b82f6) 0%, var(--secondary, #9333ea) 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    text-fill-color: transparent;\n    transition: transform 0.2s ease;\n    margin: 0;\n  }\n  \n  &:hover h1 {\n    transform: scale(1.05);\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState, useEffect } from 'react';
import { LAYOUT_BREAKPOINTS } from '@edusense/shared-constants';
import styled from '@emotion/styled';
import { Button } from '@heroui/react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { CreditCard } from 'lucide-react';
// Issue #391, #409 해결 방법 적용: BUILD.bazel data 필드 추가로 모듈 해결
import { LanguageSelector } from '@edusense/shared-i18n';
import * as m from "@paraglide/messages";
// 스타일 컴포넌트
var StyledHeader = styled.header(_templateObject());
var MaxWidthContainer = styled.div(_templateObject1());
var FlexBetween = styled.div(_templateObject2());
var LogoContainer = styled.div(_templateObject3());
var RightSection = styled.div(_templateObject4());
/**
 * 랜딩 페이지 헤더 컴포넌트
 * 
 * @example
 * ```tsx
 * <LandingPageHeader
 *   logoText="EduSense"
 *   onLogoClick={() => navigate('.')}
 *   showPricing={true}
 *   showLanguageSelector={true}
 * />
 * ```
 */ export var LandingPageHeader = function(param) {
    var logoText = param.logoText, onLogoClick = param.onLogoClick, _param_showPricing = param.showPricing, showPricing = _param_showPricing === void 0 ? false : _param_showPricing, _param_showLanguageSelector = param.showLanguageSelector, showLanguageSelector = _param_showLanguageSelector === void 0 ? false : _param_showLanguageSelector, rightActions = param.rightActions, onPricingClick = param.onPricingClick, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, logoTextStyle = param.logoTextStyle;
    var _useState = _sliced_to_array(useState(false), 2), isMobile = _useState[0], setIsMobile = _useState[1];
    // 모바일 감지
    useEffect(function() {
        var checkMobile = function() {
            setIsMobile(window.innerWidth < LAYOUT_BREAKPOINTS.TABLET_MIN);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return function() {
            return window.removeEventListener('resize', checkMobile);
        };
    }, []);
    // 반응형 최소 너비 계산
    var useResponsiveMinWidth = function(baseWidth) {
        return isMobile ? Math.max(44, baseWidth * 0.8) : baseWidth;
    };
    var computedLogoTextStyle = _object_spread({
        fontSize: '1.5rem',
        lineHeight: 1.2
    }, logoTextStyle);
    return /*#__PURE__*/ React.createElement(StyledHeader, {
        className: className
    }, /*#__PURE__*/ React.createElement(MaxWidthContainer, null, /*#__PURE__*/ React.createElement(FlexBetween, null, /*#__PURE__*/ React.createElement(LogoContainer, {
        onClick: onLogoClick
    }, /*#__PURE__*/ React.createElement("h1", {
        style: computedLogoTextStyle
    }, logoText)), /*#__PURE__*/ React.createElement(RightSection, null, showLanguageSelector && /*#__PURE__*/ React.createElement(LanguageSelector, {
        variant: "dropdown",
        showFlag: true,
        responsive: false
    }), showPricing && (isMobile ? /*#__PURE__*/ React.createElement(Button, {
        isIconOnly: true,
        variant: "flat",
        color: "primary",
        "aria-label": m.pricing_title(),
        size: "md",
        style: {
            minWidth: '44px'
        },
        onPress: onPricingClick,
        onClick: onPricingClick
    }, /*#__PURE__*/ React.createElement(CreditCard, {
        size: 20
    })) : /*#__PURE__*/ React.createElement(Button, {
        variant: "flat",
        color: "primary",
        startContent: /*#__PURE__*/ React.createElement(CreditCard, {
            size: 16
        }),
        size: "md",
        style: {
            minWidth: useResponsiveMinWidth(120),
            whiteSpace: 'nowrap'
        },
        onPress: onPricingClick,
        onClick: onPricingClick
    }, m.pricing_title())), rightActions))));
};
